import React from "react";
import cls from './LoaderModal.module.css'
import s from "../Loader/Loader.module.css";

export const LoaderModal = () => {
    return (
        <div className={cls.container}>
            <div className={s.spinner}>
                <div className={s.bounce1}></div>
                <div className={s.bounce2}></div>
                <div className={s.bounce3}></div>
            </div>
        </div>
    );
}